import { type UserType } from '@/services/types/mockUser'

export function filterByUserNameOrEmail(input: string, user: Omit<UserType, 'id'>) {
  const { email, givenName, familyName } = user

  const txt = input.toLowerCase()
  const matchName = `${givenName} ${familyName}`.toLowerCase().includes(txt)
  const matchEmail = email.toLowerCase().includes(txt)

  return matchName || matchEmail
}
